import { Stack, Box, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'
import LoginPaper from '../Login/components/LoginPaper'
import LoginButton from '../Login/components/LoginButton'
import AuthBasePageWrapper from '../Login/AuthBasePageWrapper'
import { SponsorLink } from './types'
import {
  ContentContainer,
  PageTitle,
  RecipientInfo,
  ButtonContainer,
  SuccessIcon,
  MessageContainer,
  MessageText,
  WifirstCenterText,
  RecipientTitle
} from './styles'

interface LocationState {
  sponsorLink: SponsorLink;
}

const SponsorCodeConfirmationPanel = () => {
  const { t } = useTranslation()
  const location = useLocation()
  const navigate = useNavigate()
  const theme = useTheme()
  const { sponsorLink } = (location.state as LocationState) || { sponsorLink: null }
  
  const handleBackToLogin = () => {
    navigate('/auth/login')
  }
  
  return (
    <LoginPaper sx={{ display: 'flex', justifyContent: 'center' }}>
      <ContentContainer>
        <PageTitle>{t('sponsor.page.title')}</PageTitle>
        
        <SuccessIcon>
          <i className="fa-solid fa-circle-check"></i>
        </SuccessIcon>
        
        <MessageContainer component={Stack}>
          <MessageText>
            {t('sponsor.confirmation.body.code_sent')}
          </MessageText>
          
          <Box sx={{ my: 2, textAlign: 'center' }}>
            <RecipientTitle>
              {t('sponsor.confirmation.body.recipient')}
            </RecipientTitle>
            
            <RecipientInfo sx={{ mt: 1 }}>
              <span>{sponsorLink?.first_name} {sponsorLink?.last_name}</span>
              <span>-</span>
              <span style={{ color: theme.palette.primary.main }}>{sponsorLink?.email}</span>
            </RecipientInfo>
          </Box>
          
          <MessageText sx={{ mt: 2 }}>
            {t('sponsor.confirmation.body.account_info_prefix')}
            <WifirstCenterText>
              {' '}{t('sponsor.confirmation.body.wifirst_center')}{' '}
            </WifirstCenterText>
            {t('sponsor.confirmation.body.account_info_suffix')}
          </MessageText>
        </MessageContainer>
        
        <ButtonContainer>
          <LoginButton
            onClick={handleBackToLogin}
            sx={{ width: '100%' }}
          >
            {t('sponsor.confirmation.buttons.login')}
          </LoginButton>
        </ButtonContainer>
      </ContentContainer>
    </LoginPaper>
  )
}

const SponsorCodeConfirmationPage = () => (
  <AuthBasePageWrapper>
    <SponsorCodeConfirmationPanel />
  </AuthBasePageWrapper>
)

export default SponsorCodeConfirmationPage
